import { TextColorType } from '../edit-form/crud-view-text-color-type.enum';

/**
 * Utility functions for field formatting color operations
 * Pure functions that can be used anywhere in the application
 */
export class FieldFormattingColorUtil {
  /**
   * Get text color value from color type
   * Supports both TextColorType enum and hex color strings
   */
  static getTextColorValue(colorType: TextColorType | string | undefined): string {
    if (!colorType || colorType === TextColorType.Default) {
      return '';
    }
    // If it's a hex color string, return it directly
    if (typeof colorType === 'string' && colorType.startsWith('#')) {
      return colorType;
    }
    // If it's a CSS variable, return it directly (browser will resolve it)
    if (typeof colorType === 'string' && colorType.startsWith('var(--')) {
      return colorType;
    }
    // Otherwise, map enum values to CSS variables
    const colorMap = {
      [TextColorType.Warning]: 'var(--warning-color)',
      [TextColorType.Error]: 'var(--danger-color)',
      [TextColorType.Success]: 'var(--success-color)',
      [TextColorType.Info]: 'var(--info-color)'
    };
    return colorMap[colorType as TextColorType] || '';
  }

  /**
   * Get text color indicator for dropdown menu
   */
  static getTextColorIndicator(colorType: TextColorType | string | undefined): string {
    if (!colorType || colorType === TextColorType.Default) {
      return 'transparent';
    }
    return this.getTextColorValue(colorType);
  }
}

